/*@flow*/
import mkCategoryDropdown from 'lib/mkCategoryDropdown';
import { Async } from 'react-select';
export default (mkCategoryDropdown(Async): any);
